import { request } from '@/shared/api/request'

export const getOccupationalRisk = (id) => {
	return request({ url: `/assessment/get/${id}`, method: 'GET' })
}
